/* eslint-disable react/prop-types */
import { useEffect, useState } from 'react';

import useInterval from '@hooks/useInterval';
import usePrevious from '@hooks/usePrevious';

const AutoSave = ({
  autoSaveEnabled,
  autoSaveTriggered,
  formValues,
  loadingStatus,
  listingChanged,
}) => {
  const [isDirty, setIsDirty] = useState(false);
  const previousValues = usePrevious(formValues);

  // A countdown timer can be enabled for debugging purposes
  const debugAutoSaveCountdownEnabled = false; // For debugging only - enables a countdown timer for the AutoSave
  const [counter, setCounter] = useState(30); // For debugging only - keeps track of the countdown value

  // For debugging only
  useEffect(() => {
    let timer;
    if (debugAutoSaveCountdownEnabled && counter > 0) {
      // Set countdown timer
      timer = setTimeout(() => setCounter(counter - 1), 1000);
      // eslint-disable-next-line no-console
      console.log('Seconds left to AutoSave: ', counter);
    }
    return () => timer && clearTimeout(timer);
  }, [counter]);

  const autoSaveInterval = () => {
    if (isDirty) {
      setIsDirty(false);
      autoSaveTriggered();
    }

    // For debugging only
    if (debugAutoSaveCountdownEnabled) {
      // Reset counter
      setCounter(30);
    }
  };

  // useInterval(() => autoSaveInterval(), 10000); // Just for testing
  useInterval(autoSaveInterval, autoSaveEnabled && !listingChanged ? (30 * 1000) : null);

  useEffect(() => {
    if (!loadingStatus) {
      if (previousValues && previousValues.StateOrProvince !== '') {
        if (JSON.stringify(previousValues) !== JSON.stringify(formValues)) {
          setIsDirty(true);
        }
      }
    }
  }, [formValues, loadingStatus]);

  return null;
};

export default AutoSave;
